import {createModal} from "../../helpers/modal";
import {initContractorForm} from "./form";
import {clearFeedbacksByName} from "../../helpers/forms";
import {hideLoading, showLoading} from "../../helpers/loading";
import Axios from "axios";
import handleAjaxError from "../../helpers/handleAjaxError";
import {handleAjaxSuccess} from "../../helpers/SwalHelper";

/**
 * @typedef {Object} CustomModalProperties
 * @property {() => void} submitForm
 * @property {() => any} getSubmitUrl
 * */

/**
 * @typedef {Object} ModalOptions
 * @property {(contractor: Object<string,any>) => void|undefined} [onFormSubmit]
 * @property {() => void|undefined} [onBackAction]
 * @property {boolean=false} withBackButton
 *
 * Form pass trough

 */

/**
 * Retrieves and displays a modal to create or update a contractor
 *
 * @param {ModalOptions} options
 * @return {Modal & CustomModalProperties}
 */
function createContractorFormModal(options) {
	const contractorModal = createModal({
		modalContainer: document.querySelector('.contractor-form-modal'),
		form: null,
		projectsSelect: null,
		tagsSelect: null,
		init() {
			this.form = initContractorForm(
				this.modalContainer.querySelector('form'),
			);

			this.projectsSelect = this.modalContainer.querySelector('select[name="projects"]');
			this.tagsSelect = this.modalContainer.querySelector('select[name="tags"]');

			// We need to add w-100 to the select2 container because it is initialized off screen
			// noinspection JSUnresolvedVariable
			$(this.projectsSelect).data('select2').$container.addClass('w-100');

			// We need to add w-100 to the select2 container because it is initialized off screen
			// noinspection JSUnresolvedVariable
			$(this.tagsSelect).data('select2').$container.addClass('w-100');


			// Setup back/cancel buttons
			let buttonsToDisplay;

			if (options.withBackButton) {
				buttonsToDisplay = this.modalContainer.querySelector('.back-and-cancel-buttons');

				// Trigger on back action if set
				this.modalContainer.querySelector('.back-button').addEventListener('click', () => {
					if (options.onBackAction) {
						options.onBackAction();
					}
				});

				// Setup back event handler
			} else {
				buttonsToDisplay = this.modalContainer.querySelector('.cancel-only-button');
			}

			// Display buttons container
			buttonsToDisplay.classList.remove('d-none');
			buttonsToDisplay.classList.add('d-flex');

			// Add event to submit button
			this.modalContainer
				.querySelector('.contractor-form-modal-confirm-button')
				.addEventListener('click', () => {
					this.submitForm();
				})
		},
		submitForm() {
			showLoading()

			clearFeedbacksByName(this.form.formElement);

			Axios.post(this.getSubmitUrl(), this.form.getValues())
				.then(response => {
					handleAjaxSuccess(response, () => {
						// Display success message and get back to caller
						if (options.onFormSubmit) {
							options.onFormSubmit(response.data.contractor)
						}
					})
				})
				.catch(error => handleAjaxError(error, this.form.formElement))
				.finally(hideLoading)
		},
		getSubmitUrl() {
			return this.modalContainer.querySelector('input[name="contractor_modal_submit_url"]').value;
		}
	});

	// Replace display function to clean up inputs when displayed
	contractorModal.__old_display = contractorModal.display;

	contractorModal.display = (scrollUp) => {
		// Clean up inputs
		const form = contractorModal.form;

		form.clearFeedbacks();
		form.clearInputs();

		// Preselect project if needed
		if (window['__contractor_modal_preselected_project__']) {
			form.selectProject(window['__contractor_modal_preselected_project__']);
		}

		contractorModal.__old_display(scrollUp);
	}

	return contractorModal;
	/** Methods */

}


export {createContractorFormModal}
